import { Injectable } from '@angular/core';
import { Observable, from} from 'rxjs';
import { shareReplay, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import AppConfig from 'aws-sdk/clients/appconfig';
import { fetchAuthSession } from 'aws-amplify/auth';
import AWS, { CognitoIdentityCredentials } from 'aws-sdk';

export type ReferralConfig = {
  [key: string]: string;  // Map of employer codes to names
}

@Injectable({ providedIn: 'root' })
export class AppConfigService {
  private configCache$: Observable<ReferralConfig>;
  private appConfig: AppConfig;

  private async initializeAppConfig() {
    if (this.appConfig) return;  // Already initialized

    const { tokens } = await fetchAuthSession();
    AWS.config.region = environment.cognitoIdentityPoolId.split(":")[0];

    const credentials = new CognitoIdentityCredentials({
      IdentityPoolId: environment.cognitoIdentityPoolId,
      Logins: {
        [`cognito-idp.${AWS.config.region}.amazonaws.com/${environment.cognitoUserPoolId}`]: tokens.idToken.toString()
      }
    });

    await credentials.getPromise();
    this.appConfig = new AppConfig({ credentials });
  }

  getConfig(): Observable<ReferralConfig> {
    if (!this.configCache$) {
      this.configCache$ = from((async () => {
        await this.initializeAppConfig();
        return this.appConfig.getConfiguration({
          Application: environment.appConfig.application,
          Environment: environment.appConfig.environment,
          Configuration: environment.appConfig.configurationProfile,
          ClientId: environment.ClientId
        }).promise();
      })()).pipe(
        map(response => JSON.parse(response.Content.toString())),
        shareReplay(1)  // Cache the last emitted value
      );
    }
    return this.configCache$;
  }
}
